import { useEffect } from 'react';
import type { InfraInstances } from '@/api/observability';
import { listInfraInstances } from '@/api/observability';
import { useApiQuery } from './useApiQuery';

const REFRESH_INTERVAL_MS = 30_000;

interface UseInfraInstancesResult {
  data: InfraInstances | undefined;
  isLoading: boolean;
  error: string | undefined;
  reload: () => void;
}

/**
 * Fetches the per-instance drill-down for an infrastructure dependency (e.g.
 * every Oracle database). Polls on the same cadence as the Observability page.
 */
export const useInfraInstances = (id: string): UseInfraInstancesResult => {
  const query = useApiQuery<InfraInstances>(
    {
      queryFn: (signal) => listInfraInstances(id, signal),
    },
    [id],
  );

  const { reload } = query;
  useEffect(() => {
    const timer = setInterval(reload, REFRESH_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [reload]);

  return {
    data: query.data,
    isLoading: query.isLoading,
    error: query.error,
    reload: query.reload,
  };
};
